import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Select from "react-select";

import LatestStrainTable from "./components/latestStrainTable/latestStrainTable";
import LatestStrainBySubmissionDateTable from "./components/latestStrainTableBySubmissionDate/latestStrainTable";
import FrequencyGraph from "./components/frequencyGraph/frequencyGraph";
import CountryTable from "./components/countryTable/countryTable";
import MapWithToolTip from "./components/map/mapWithToolTip";
import PDBStructure from "./components/PDBStructure/PDBStructure";
import { addThousandSeparator } from "./util/parseTableData";

import AppStyle from "./App.module.css";
import {
  getIFrameData,
  getTextLiteral,
  getVariantOptions,
  getDisclaimerBeforeTree,
  getDisclaimerAfterTree,
  getPDBStructureConfig,
  getTopDisclaimer,
  getVariantName
} from "./service/textRetrieval";

import {getCountryCountTotalData} from "./service/countryCountTotalData";

function App() {
  const [textLiterals, setTextLiterals] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(true);
  const [topDisclaimer, setTopDisclaimer] = React.useState("");
  const [topDisclaimerTmp, setTopDisclaimerTmp] = React.useState("");
  const [countryCountTotalData, setCountryCountTotalData]=React.useState([{"totalNumIsolates": "", "totalNumCountries": "", "utcTimestamp":""}]);
  const [disclaimer, setDisclaimer] = React.useState([]);
  const [disclaimerAfterTree, setDisclaimerAfterTree] = React.useState([]);
  const [iFrameData, setIFrameData] = React.useState({});
  const [PDBStructureConfig, setPDBStructureConfig] = React.useState({});
  const [variantOptions, setVariantOptions] = React.useState([]);
  const [variantName, setVariantName] = React.useState("");
  const [variant, setVariant] = React.useState(
    process.env.REACT_APP_DEFAULT_VARIANT
  );
  React.useEffect(() => {
    getTextLiteral().then((textLiterals) => {
      setTextLiterals(textLiterals);
      setTopDisclaimerTmp(getTopDisclaimer(textLiterals));
      setDisclaimer(getDisclaimerBeforeTree(textLiterals));
      setDisclaimerAfterTree(getDisclaimerAfterTree(textLiterals));
      setVariantOptions(getVariantOptions(textLiterals));
      setIFrameData(getIFrameData(variant, textLiterals));
      setPDBStructureConfig(getPDBStructureConfig(variant, textLiterals));
      setVariantName(getVariantName(variant,textLiterals));
      setIsLoading(false);
    });
    getCountryCountTotalData(variant).then((result)=>{
      if(result!=null){
        setCountryCountTotalData(result[0]);
      }
    })
  }, [variant]);

  React.useEffect(() => {
    setTopDisclaimer(topDisclaimerTmp.replace("<utcTimestamp>", countryCountTotalData?countryCountTotalData.utcTimestamp:"").replace("<totalNumIsolates>", addThousandSeparator(countryCountTotalData?countryCountTotalData.totalNumIsolates:"")).replace("<totalNumCountries>", addThousandSeparator(countryCountTotalData?countryCountTotalData.totalNumCountries:"")).replace("<variantName>",variantName))
    // setIsLoading(false);
  },[topDisclaimerTmp,countryCountTotalData,variantName]);

  return isLoading ? null : (
    <Container className={AppStyle.container}>
      <div className={AppStyle.variantSelectContainer}>
        <Select
          className={AppStyle.variantSelect}
          isDisabled={false}
          isLoading={false}
          isClearable={false}
          isSearchable={true}
          name="Variant Name"
          value={variantOptions.filter((option) => option.value === variant)}
          options={variantOptions}
          onChange={(e) => setVariant(e.value)}
        />
      </div>
      <Row className="mb-3 mt-5 justify-content-md-center">
        <div className={AppStyle.topDisclaimer}>
            {topDisclaimer}
        </div>
      </Row>
      <Row className="mb-3 mt-3">
        <Col xs={12} lg={7} className="mb-4">
          <MapWithToolTip variant={variant} textLiterals={textLiterals} />
        </Col>
        <Col xs={12} lg={5} className="mb-4">
          <FrequencyGraph variant={variant} textLiterals={textLiterals} />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col xs={12} lg={6} className="mb-3 mb-xs-4 mb-md-4 mb-sm-4">
          <LatestStrainBySubmissionDateTable variant={variant} textLiterals={textLiterals} />
        </Col>
        <Col xs={12} lg={6} className="mb-3 mb-xs-4 mb-md-4 mb-sm-4">
          <CountryTable variant={variant} textLiterals={textLiterals} />
        </Col>
      </Row>
      <Row className="mt-1">
        <Col xs={12} lg={6} className="mb-3 mb-xs-4 mb-md-4 mb-sm-4">
          <LatestStrainTable variant={variant} textLiterals={textLiterals} />
        </Col>
        {PDBStructureConfig.show ? (
      
        <Col xs lg={6} className="mb-3 mb-xs-4 mb-md-4 mb-sm-4">
          <PDBStructure variant={variant} textLiterals={textLiterals}  />
        </Col>
      
      ) : null}
      </Row>
      {disclaimer.length === 0 ? null : (
        <Row className="mb-3">
          {disclaimer.map((claim, index) => {
            return (
              <div key={index} className={AppStyle.disclaimer}>
                {claim}
              </div>
            );
          })}
        </Row>
      )}
      {iFrameData.show ? (
        <Row className="mb-4">
          <iframe
            title="Tree"
            src={iFrameData.link}
            style={{
              border: "none",
              width: "100%",
              height: "600px",
            }}
            className="mb-3"
          />
        </Row>
      ) : null}
      {/* {PDBStructureConfig.show ? (
       <Row className="mt-3 justify-content-md-center">
        <Col xs lg={10} className="mb -3 mb-xs-4 mb-md-4 mb-sm-4">
          <PDBStructure variant={variant} textLiterals={textLiterals}/>
        </Col>
      </Row>
      ) : null} */}
      <Row className="mb-3">
        {disclaimerAfterTree.map((claim, index) => {
          return (
            <div key={index} className={AppStyle.disclaimer}>
              {claim}
            </div>
          );
        })}
      </Row>
    </Container>
  );
}

export default App;
